export const selectPanels = state => state.panels


// WEBPACK FOOTER //
// ./web/js/panels/selector.js